import React, { useEffect, useState } from "react";
import { Card, Typography, FormControlLabel, Box, Stack } from "@mui/material";
import IOSSwitch from "./IOSSwitch";
import paymentCategoryLogoDictionary from "../paymentCategoryLogoDictionary";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import { colorBrandObject } from "../../../constants/brandings";
import { readableColor } from "polished";
const PaymentCategory = ({
  obj,
  title,
  disabledPaymentIds,
  updateDisabledPaymentIds,
  numberOfPaymentMethods,
  updateNumberOfPaymentMethods,
}) => {
  const [toggle, setToggle] = useState(false);
  const [toggalModal, setToggalModal] = useState(false);

  useEffect(() => {
    const id = obj[0]?.id;
    if (disabledPaymentIds?.find((ele) => ele === id)) {
      setToggle(false);
    } else {
      setToggle(true);
    }
  }, [disabledPaymentIds]);

  const handleChange = () => {
    if (numberOfPaymentMethods == 1 && toggle == true) {
      setToggalModal(true);
    } else {
      let paymentIdArray = [];
      for (let index = 0; index < obj.length; index++) {
        paymentIdArray.push(obj[index]?.id);
      }
      updateDisabledPaymentIds(!toggle, paymentIdArray);
    }
  };

  return (
    <>
      <SmallModal
        headerText={"Payment Method Required"}
        subHeaderText={
          "Please add atleast one payment method to accept payment on your checkout"
        }
        toggleDialog={toggalModal}
        filledBtnText={"Got it"}
        filledBtnFunction={() => setToggalModal(false)}
      />
      <Card
        variant="outlined"
        sx={{
          minWidth: 268,
          minHeight: 60,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            marginLeft: "10px",
            marginRight: "10px",
            height: "32px",
            borderRadius: "2px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={paymentCategoryLogoDictionary[title]?.logo}
            stylt={{ width: "20", height: "24" }}
          />
        </Box>

        <Stack
          direction="row"
          spacing={1}
          sx={{
            width: "100%",
            height: "28px",
            padding: "3px 1px 3px 3px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "500",
              color: "rgba(1, 1, 2, 0.92)",
            }}
          >
            {obj[0]?.typeTitle == "Card" || obj[0]?.typeTitle == "Wallet"
              ? obj[0]?.typeTitle + "s"
              : obj[0]?.typeTitle}
          </Typography>

          <FormControlLabel
            id={Math.random()}
            control={
              <IOSSwitch
                sx={{
                  m: 1, "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "white"
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: colorBrandObject?.secondaryButtonColor,
                  },
                }}
                onChange={handleChange}
                checked={toggle}
                id={Math.random()}
              />
            }
          />
        </Stack>
      </Card>
    </>
  );
};

export default PaymentCategory;
